import Column from '@components/Column';
import Description from '@components/Description';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import Notice from '@icons/Notice';
import { KiccCardRow } from '@models/easyCard/kicc';
import { useTranslation } from 'react-i18next';

import EasyCardItem from './EasyCardItem';

interface Props {
    cards?: KiccCardRow[];
}

function EasyCardContents({ cards }:Props) {
    const { t } = useTranslation('easyCard');
    if (cards?.length === 0) {
        return null;
    }
    return (
        <Column fullWidth >
            <DescriptionWrapper>
                <Description>
                    <Notice color={colors.primary} size={16}/>
                    <Text color={colors.textSecondary} size='body-short'>
                        {t('list.maxNotice')}
                    </Text>
                </Description>
            </DescriptionWrapper>
            {cards?.map((easyCard) => (
                <EasyCardItem easyCard={easyCard}
                    key={easyCard.cardId} />
            ))}
        </Column>
    );
}

const DescriptionWrapper = styled.div`
    width: 100%;
    //padding: var(--spacing-4);
    padding: 16px;
`;

export default EasyCardContents;
